import { action, runInAction, observable } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import feedbackController from './feedbackController';

export interface FeedbackStore {
  feedbackList: any[],
  myList: any[],
  categories: any[],
  statuses: any[],
  error: ErrorInterface,
}

const initialValues: FeedbackStore = {
  feedbackList: [],
  myList: [],
  categories: [],
  statuses: [],
  error: null,
};

export const feedbackStore = observable(initialValues);

export const feedbackActions = {

  // Список всех обращений (доступен только federal-пользователям — проверяется на backend).
  async getFeedbackList() {
    feedbackActions.clearError();
    const response = await feedbackController.getList();
    feedbackActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        feedbackStore.feedbackList = response.data ?? [];
      }
    });
  },

  // Свои обращения текущего пользователя (любой авторизованный; backend фильтрует по автору).
  async getMy() {
    feedbackActions.clearError();
    const response = await feedbackController.getMy();
    feedbackActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        feedbackStore.myList = response.data ?? [];
      }
    });
  },

  // Категории обращений для формы отправки.
  async getCategories() {
    feedbackActions.clearError();
    const response = await feedbackController.getCategories();
    feedbackActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        feedbackStore.categories = response.data ?? [];
      }
    });
  },

  // Возможные статусы обращений (для селекта смены статуса).
  async getStatuses() {
    feedbackActions.clearError();
    const response = await feedbackController.getStatuses();
    feedbackActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        feedbackStore.statuses = response.data ?? [];
      }
    });
  },

  // Отправка обращения. Возвращает созданную запись.
  async create(request) {
    feedbackActions.clearError();
    const response = await feedbackController.create(request);
    feedbackActions.handleError(response);
    return response.data;
  },

  // Смена статуса обращения (federal). Возвращает обновлённую запись.
  async updateStatus(id, status) {
    feedbackActions.clearError();
    const response = await feedbackController.updateStatus(id, status);
    feedbackActions.handleError(response);
    return response.data;
  },

  // Изменение/очистка комментария обработчика (federal). Возвращает обновлённую запись.
  async updateHandlerComment(id, comment) {
    feedbackActions.clearError();
    const response = await feedbackController.updateHandlerComment(id, comment);
    feedbackActions.handleError(response);
    return response.data;
  },

  clearFeedbackList: action(() => {
    feedbackStore.feedbackList = [];
  }),

  clearMyList: action(() => {
    feedbackStore.myList = [];
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      feedbackStore.error = {
        message: errorData?.message,
        errorCode: errorData?.errorCode,
        timestamp: errorData?.timestamp,
        status: response?.status,
        connectError: response?.connectError,
        isError: response?.error,
      };
      throw errorData;
    }
  }),

  async clearError() {
    feedbackStore.error = null;
  },

};
